import { useState } from "react";
import { fetchAllPagesForExport } from "src/utils/pdfExport/fetchAllPagesForExport";

export function useDashboardPdfRowOverride<TRow>(
  currentPageRows: TRow[],
  loadAllRows: () => Promise<TRow[]>,
) {
  const [exportRows, setExportRows] = useState<TRow[] | null>(null);

  const onBeforeCapture = async () => {
    const allRows = await loadAllRows();
    setExportRows(allRows);
  };

  const onAfterCapture = () => {
    setExportRows(null);
  };

  return {
    rows: exportRows ?? currentPageRows,
    onBeforeCapture,
    onAfterCapture,
  };
}

export function useDashboardPdfTableExpansion<TRow>(
  currentPageRows: TRow[],
  fetchPage: (_page: number, _pageSize: number) => Promise<{ rows: TRow[]; total: number }>,
  pageSize: number = 100,
) {
  return useDashboardPdfRowOverride(
    currentPageRows,
    () => fetchAllPagesForExport({ fetchPage, pageSize }),
  );
}
